"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timestamp = exports.Row = exports.List = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _helpers = require("../helpers");
var _mixins = require("../mixins");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* Row Components ************************************** */

var Timestamp = _styledComponents["default"].div.withConfig({
  displayName: "ListParts__Timestamp",
  componentId: "sc-1bg2wqc-0"
})(["flex:0 0 auto;margin-left:auto;padding-left:", ";font-size:", ";color:", ";position:relative;"], function (props) {
  return props.theme.spaces.xs;
}, function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return (0, _helpers.getColor)(props, "color", "textSecondary");
});
exports.Timestamp = Timestamp;
Timestamp.displayName = "List.Timestamp";

/* Row  ************************************** */
var Row = _styledComponents["default"].li.withConfig({
  displayName: "ListParts__Row",
  componentId: "sc-1bg2wqc-1"
})(["width:100%;display:flex;flex-direction:", ";align-items:", ";justify-content:", ";"], function (props) {
  return props.direction || "row";
}, function (props) {
  return props.alignItems || "center";
}, function (props) {
  return props.justifyContent || "flex-start";
});
exports.Row = Row;
Row.displayName = "List.Row";

/* List ************************************** */
var List = _styledComponents["default"].ul.withConfig({
  displayName: "ListParts__List",
  componentId: "sc-1bg2wqc-2"
})(["", ";", ";font-size:", ";color:", ";", "{", ";&:last-child{&::after{display:none;}}}", ""], _mixins.listBareMixin, function () {
  return (0, _mixins.padMyChildrenMixin)(Row);
}, function (props) {
  return props.theme.fontSizes.base;
}, function (props) {
  return (0, _helpers.getColor)(props, "color", "text");
}, Row, _mixins.separatorMixin, function (props) {
  return props.showSeparatorLastChild && (0, _styledComponents.css)(["", ":last-child{&::after{display:block;}}"], Row);
});
exports.List = List;
List.displayName = "List";